module.exports = __webpack_public_path__ + "img/background.b8b4fe95.jpg";